import { styled } from "@mui/material/styles";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import React from "react";

type TableData = {
	headers: string[];
	rows: JSX.Element[][];
};

const StyledTableCell = styled(TableCell)(({ theme }) => ({
	[`&.${tableCellClasses.head}`]: {
		color: "#545859",
		borderBottom: "2px solid #545859",
		padding: 10,
		fontSize: 14,
		lineHeight: "16px",
		fontWeight: 700,
	},
	[`&.${tableCellClasses.body}`]: {
		fontSize: 14,
		borderRight: "1px solid #CCCCCC",
		padding: 0,
		borderBottom: 0,
	},
	[`&.${tableCellClasses.body}:last-child`]: {
		borderRight: 0,
	},
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
	"&:nth-of-type(odd)": {
		backgroundColor: theme.palette.secondary.light,
	},
	"&:hover": {
		backgroundColor: "#F1F1F1",
	},
}));

const TabTable = ({
	tableData,
	loading,
}: {
	tableData: TableData;
	loading?: boolean;
}) => {
	return (
		<TableContainer component={Paper} sx={{ boxShadow: "none" }}>
			<Table sx={{ minWidth: 700 }} stickyHeader>
				<TableHead>
					<TableRow>
						{tableData?.headers.map((header, index) => (
							<StyledTableCell
								key={index}
								dangerouslySetInnerHTML={{ __html: header }}
							/>
						))}
					</TableRow>
				</TableHead>
				<TableBody>
					{!loading &&
						tableData?.rows.map((row, index) => (
							<StyledTableRow key={index}>
								{row.map((cell, index) => (
									<StyledTableCell key={index}>
										{cell}
									</StyledTableCell>
								))}
							</StyledTableRow>
						))}
					{!tableData?.rows.length && !loading && (
						<StyledTableRow>
							<StyledTableCell
								colSpan={tableData.headers.length}
								sx={{
									height: "50px",
									textAlign: "center",
								}}
							>
								Couldn't find any results
							</StyledTableCell>
						</StyledTableRow>
					)}
					{loading && (
						<StyledTableRow>
							<StyledTableCell
								colSpan={tableData.headers.length}
								sx={{
									height: "50px",
									textAlign: "center",
								}}
							>
								Loading...
							</StyledTableCell>
						</StyledTableRow>
					)}
				</TableBody>
			</Table>
		</TableContainer>
	);
};

export default TabTable;
